module.exports = __webpack_public_path__ + "static/media/redecorating_important.913b7f04.svg";